/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VeetingMeetingDto } from '../../models/veeting-meeting-dto';

export interface GetVeetingMeeting$Params {
  'X-API-Version'?: string;
}

export function getVeetingMeeting(http: HttpClient, rootUrl: string, params?: GetVeetingMeeting$Params, context?: HttpContext): Observable<StrictHttpResponse<VeetingMeetingDto>> {
  const rb = new RequestBuilder(rootUrl, getVeetingMeeting.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VeetingMeetingDto>;
    })
  );
}

getVeetingMeeting.PATH = '/api/veeting-meeting';
